import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaInstagram } from "react-icons/fa";
import { FaWifi } from "react-icons/fa";
import { MdOutlineSignalCellularConnectedNoInternet4Bar } from "react-icons/md";
import { MdBatteryFull } from "react-icons/md";
import { FaShop } from "react-icons/fa6";
import { RxDotsVertical } from "react-icons/rx";
import { CiEdit } from "react-icons/ci";
import { FaCheck } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { FaCopy } from "react-icons/fa6";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoIosArrowDown } from "react-icons/io";
import { MdOutlineSave } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import {
    BsTypeH1, BsTypeH2, BsCardText, BsTextParagraph,
    BsInputCursorText, BsKey, BsEnvelope, BsTelephone,
    BsHash, BsLock, BsJustifyLeft, BsCalendarDate,
    BsRecordCircle, BsCheckSquare, BsCaretDownSquare,
    BsToggleOn, BsImage
} from "react-icons/bs";
import whatsappBgimage from '../images/whatsapp-mobile-image.png'
import whatsappnotch from '../images/Wp-notch-image.png'
import Whatsappicon from '../images/Whatsappicon.png'

// ─── API base URL — change to your backend ──────────────────────────────────
const API_BASE = `${process.env.REACT_APP_API_BASE}/auth/api` || '';
const API_URL = process.env.REACT_APP_API_BASE || "https://wa-api.globebot.io";
function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch {
        return {};
    }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

// ─── API helpers ─────────────────────────────────────────────────────────────
const api = {
    getFlow: (id) => fetch(`${API_BASE}/flows/${id}`)
        .then(r => r.json())
        .then(r => ({ success: r.ok, data: r.data, message: r.error })),

    createFlow: (body) => fetch(`${API_BASE}/flows`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(r => r.json()).then(r => ({ success: r.ok, data: r.data, message: r.error })),

    saveFlow: (id, body) => fetch(`${API_BASE}/flows/${id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(r => r.json()).then(r => ({ success: r.ok, data: r.data, message: r.error })),

    getResponses: (flowId, page = 1) =>
        fetch(`${API_BASE}/flows/${flowId}/responses?page=${page}&limit=20`)
        .then(r => r.json())
        .then(r => ({ success: r.ok, data: r.data, message: r.error })),
};
// ─── Map DB shape → local state shape ───────────────────────────────────────
function dbScreenToLocal(screen) {
    return {
        id: screen.id,
        text: screen.title,
        footer: screen.footer_button_text,
        containers: (screen.containers || []).map(c => ({
            id: c.id,
            bodyFont: c.body_font,
            bodyvalue: c.body_value,
        }))
    };
}

// ─── Map local state → API payload ──────────────────────────────────────────
function buildPayload(waba_id, business_id, flow_type, screens) {
    return {
        waba_id,
        business_id,
        flow_type,
        status: 'draft',
        screens: screens.map((s, i) => ({
            title: s.text,
            footer_button_text: s.footer,
            sort_order: i,
            containers: s.containers.map((c, j) => ({
                bodyFont: c.bodyFont,
                body_value: c.bodyvalue,
                sort_order: j,
            }))
        }))
    };
}
// ─── Content options ─────────────────────────────────────────────────────────
const contentOptions = [
    {
        category: "TEXT",
        items: [
            { text: "Large heading", icon: BsTypeH1, bodyFont: "Largeheading", bodyvalue: "Large Heading" },
            { text: "Small heading", icon: BsTypeH2, bodyFont: "Smallheading", bodyvalue: "Small Heading" },
            { text: "Caption",       icon: BsCardText, bodyFont: "Caption", bodyvalue: "Caption text" },
            { text: "Body",          icon: BsTextParagraph, bodyFont: "Body", bodyvalue: "Body text" }
        ]
    },
    {
        category: "TEXT ANSWER",
        items: [
            { text: "Text",        icon: BsInputCursorText, bodyFont: "Body", bodyvalue: "Text field" },
            { text: "Passcode",    icon: BsKey,             bodyFont: "Body", bodyvalue: "Passcode" },
            { text: "Email",       icon: BsEnvelope,        bodyFont: "Body", bodyvalue: "Email" },
            { text: "Phone",       icon: BsTelephone,       bodyFont: "Body", bodyvalue: "Phone number" },
            { text: "Number",      icon: BsHash,            bodyFont: "Body", bodyvalue: "Number" },
            { text: "Password",    icon: BsLock,            bodyFont: "Body", bodyvalue: "Password" },
            { text: "Paragraph",   icon: BsJustifyLeft,     bodyFont: "Body", bodyvalue: "Paragraph text" },
            { text: "Date Picker", icon: BsCalendarDate,    bodyFont: "Body", bodyvalue: "Pick a date" }
        ]
    },
    {
        category: "SELECTION",
        items: [
            { text: "Single Choice", icon: BsRecordCircle,    bodyFont: "Body", bodyvalue: "Option 1\nOption 2" },
            { text: "Multi Choice",  icon: BsCheckSquare,     bodyFont: "Body", bodyvalue: "Option A\nOption B" },
            { text: "Dropdown",      icon: BsCaretDownSquare, bodyFont: "Body", bodyvalue: "Select..." },
            { text: "Opt-in",        icon: BsToggleOn,        bodyFont: "Body", bodyvalue: "I agree" }
        ]
    },
    {
        category: "MEDIA",
        items: [
            { text: "Image", icon: BsImage, bodyFont: "Body", bodyvalue: "[Image]" }
        ]
    }
];

// ─── Toast notification ──────────────────────────────────────────────────────
function Toast({ message, type, onClose }) {
    useEffect(() => {
        const t = setTimeout(onClose, 3000);
        return () => clearTimeout(t);
    }, [onClose]);
    const colors = {
        success: 'bg-[#31b07b] text-white',
        error: 'bg-[#ed5050] text-white',
        loading: 'bg-[#37715d] text-white'
    };
    return (
        <div className={`fixed bottom-6 right-6 z-50 px-4 py-3 rounded-lg shadow-lg text-[13px] font-bold flex items-center gap-2 ${colors[type]}`}>
            {type === 'loading' && <AiOutlineLoading3Quarters className="animate-spin" />}
            {message}
        </div>
    );
}

// ─── Responses tab ───────────────────────────────────────────────────────────
function ResponsesTab({ flowId }) {
    const [data, setData] = useState(null);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!flowId) return;
        setLoading(true);
        api.getResponses(flowId, page)
            .then(r => r.success && setData(r.data))
            .finally(() => setLoading(false));
    }, [flowId, page]);

    if (!flowId) return (
        <div className="flex flex-col items-center justify-center h-64 text-[#61748f]">
            <p className="text-[14px]">Save your flow first to see responses.</p>
        </div>
    );

    if (loading) return (
        <div className="flex items-center justify-center h-64">
            <AiOutlineLoading3Quarters className="animate-spin text-[#37715d] text-2xl" />
        </div>
    );

    if (!data || data.rows.length === 0) return (
        <div className="flex flex-col items-center justify-center h-64 text-[#61748f]">
            <FaWhatsapp className="text-4xl mb-2 text-[#37715d]" />
            <p className="text-[14px]">No responses yet.</p>
        </div>
    );

    return (
        <div className="p-4 max-w-4xl">
            <p className="text-[12px] text-[#61748f] mb-3">{data.total} total response{data.total !== 1 ? 's' : ''}</p>
            <div className="overflow-x-auto rounded-lg border border-[#e3e9ef]">
                <table className="w-full text-[12px]">
                    <thead className="bg-[#f5f8fa]">
                        <tr>
                            <th className="text-left p-3 text-[#576071] font-bold">ID</th>
                            <th className="text-left p-3 text-[#576071] font-bold">Screen</th>
                            <th className="text-left p-3 text-[#576071] font-bold">Session</th>
                            <th className="text-left p-3 text-[#576071] font-bold">Data</th>
                            <th className="text-left p-3 text-[#576071] font-bold">Submitted</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.rows.map((r, i) => (
                            <tr key={r.id} className={i % 2 === 0 ? 'bg-white' : 'bg-[#fafbfc]'}>
                                <td className="p-3 text-[#576071]">#{r.id}</td>
                                <td className="p-3 text-[#576071]">{r.screen_title || '—'}</td>
                                <td className="p-3 text-[#576071] font-mono">{r.session_id || '—'}</td>
                                <td className="p-3 text-[#576071] max-w-[200px] truncate">
                                    {JSON.stringify(r.response_data)}
                                </td>
                                <td className="p-3 text-[#576071]">
                                    {new Date(r.submitted_at).toLocaleString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {data.total > data.limit && (
                <div className="flex items-center gap-2 mt-3">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage(p => p - 1)}
                        className="px-3 py-1 rounded border border-[#e3e9ef] text-[12px] disabled:opacity-40"
                    >← Prev</button>
                    <span className="text-[12px] text-[#61748f]">Page {page}</span>
                    <button
                        disabled={page * data.limit >= data.total}
                        onClick={() => setPage(p => p + 1)}
                        className="px-3 py-1 rounded border border-[#e3e9ef] text-[12px] disabled:opacity-40"
                    >Next →</button>
                </div>
            )}
        </div>
    );
}

// ─── Main Component ──────────────────────────────────────────────────────────
function AddEditFlow() {
    const { id: routeId } = useParams();           // undefined = new flow
    const navigate = useNavigate();

    // ── State ────────────────────────────────────────────────────────────────
    const [flowId, setFlowId] = useState(routeId ? Number(routeId) : null);
    const [flowName, setFlowName] = useState('New Flow');
    const [flowtype, setflowtype] = useState('build');
    const [saving, setSaving] = useState(false);
    const [loadingFlow, setLoadingFlow] = useState(!!routeId);
    const [toast, setToast] = useState(null);
    const[wabadata,setWabadata] = useState([]);
    const{userId,token} = getUserIdFromToken();

    useEffect(() => {
        if (!token) return;
        fetch(`${API_URL}/auth/my-whatsapp`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) setWabadata(data);
                else if (data && Array.isArray(data.data)) setWabadata(data.data);
                else setWabadata([]);
            })
            .catch(() => setWabadata([]));
    }, [token]);

    const defaultScreen = {
        id: Date.now(),
        text: 'Screen 1',
        containers: [{ id: Date.now() + 1, bodyFont: 'Body', bodyvalue: 'Body' }],
        footer: 'Continue'
    };

    const [ScreenTabs, setScreenTabs] = useState([defaultScreen]);
    const [selectedScreen, SetselectedScreen] = useState(defaultScreen);
    const [activeTabId, setActiveTabId] = useState(defaultScreen.id);

    const [isEditScreenTitle, setisEditScreetitle] = useState(false);
    const [newTitle, setnewTitle] = useState('');
    const [selectedId, setSelectedId] = useState(null);
    const [isAddcontent, setisAddcontent] = useState(false);

    // ── Load existing flow ───────────────────────────────────────────────────
    useEffect(() => {
        if (!routeId) return;
        setLoadingFlow(true);
        api.getFlow(routeId).then(r => {
            if (!r.success) { showToast('Failed to load flow', 'error'); return; }
            const flow = r.data;
            setFlowName(flow.business_name);
            setflowtype(flow.flow_type || 'build');
            const screens = (flow.screens || []).map(dbScreenToLocal);
            if (screens.length) {
                setScreenTabs(screens);
                SetselectedScreen(screens[0]);
                setActiveTabId(screens[0].id);
            }
        }).finally(() => setLoadingFlow(false));
    }, [routeId]);

    // ── Toast helper ─────────────────────────────────────────────────────────
    const showToast = useCallback((message, type = 'success') => {
        setToast({ message, type });
    }, []);

    // ── Save flow ─────────────────────────────────────────────────────────────
    const saveFlow = async () => {
        if (!wabadata.length) {
            showToast('No WhatsApp account found', 'error');
            return;
        }
        setSaving(true);
        showToast('Saving…', 'loading');
        try {
            const payload = buildPayload(wabadata[0].waba_id, wabadata[0].phone_number_id , flowtype, ScreenTabs);

            let result;
            if (flowId) {
                result = await api.saveFlow(flowId, payload);
            } else {
                result = await api.createFlow(payload);
                if (result.success) {
                    const newId = result.data.id;
                    setFlowId(newId);
                    navigate(`/WAMessage/WAFlow/${newId}/edit`, { replace: true });
                }
            }

            if (result.success) {
                showToast('Flow saved!', 'success');
            } else {
                showToast('Save failed: ' + result.message, 'error');
            }
        } catch (e) {
            showToast('Network error', 'error');
        } finally {
            setSaving(false);
        }
    };

    // ── Screen helpers ────────────────────────────────────────────────────────
    const addScreen = () => {
        const newScreen = {
            id: Date.now(),
            text: `Untitled Screen ${ScreenTabs.length + 1}`,
            containers: [{ id: Date.now() + 1, bodyFont: 'Body', bodyvalue: 'Body' }],
            footer: 'Continue'
        };
        setScreenTabs(prev => [...prev, newScreen]);
    };

    const activeScreen = (id) => {
        const found = ScreenTabs.find(item => item.id === id);
        if (found) { SetselectedScreen(found); setActiveTabId(id); }
    };

    const deleteButton = (id) => {
        const updated = ScreenTabs.filter(item => item.id !== id);
        setScreenTabs(updated);
        if (activeTabId === id && updated.length) {
            SetselectedScreen(updated[0]);
            setActiveTabId(updated[0].id);
        }
    };

    const updatetitle = () => {
        setScreenTabs(prev => prev.map(item =>
            item.id === selectedId ? { ...item, text: newTitle } : item
        ));
        SetselectedScreen(prev => ({ ...prev, text: newTitle }));
    };

    // Push local selectedScreen edits back into ScreenTabs
    const syncSelectedScreen = useCallback((updatedScreen) => {
        SetselectedScreen(updatedScreen);
        setScreenTabs(prev => prev.map(tab =>
            tab.id === updatedScreen.id ? updatedScreen : tab
        ));
    }, []);

    // ── Container helpers ─────────────────────────────────────────────────────
    const addContainer = (font = 'Body', value = '') => {
        const updated = {
            ...selectedScreen,
            containers: [...selectedScreen.containers, { id: Date.now(), bodyFont: font, bodyvalue: value }]
        };
        syncSelectedScreen(updated);
    };

    const duplicateContainer = (index) => {
        const containers = [...selectedScreen.containers];
        const copy = { ...containers[index], id: Date.now() };
        containers.splice(index + 1, 0, copy);
        syncSelectedScreen({ ...selectedScreen, containers });
    };

    const deletebodyitem = (id) => {
        if (selectedScreen.containers.length <= 1) return;
        syncSelectedScreen({
            ...selectedScreen,
            containers: selectedScreen.containers.filter(c => c.id !== id)
        });
    };

    const updateContainer = (index, field, value) => {
        const containers = [...selectedScreen.containers];
        containers[index] = { ...containers[index], [field]: value };
        syncSelectedScreen({ ...selectedScreen, containers });
    };

    // ── Loading state ─────────────────────────────────────────────────────────
    if (loadingFlow) {
        return (
            <div className="flex items-center justify-center h-screen">
                <AiOutlineLoading3Quarters className="animate-spin text-[#37715d] text-3xl" />
            </div>
        );
    }

    // ── Render ────────────────────────────────────────────────────────────────
    return (
        <>
            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(null)}
                />
            )}

            <div className='dark:bg-[#121519] pt-[100px] sm:pt-[70px] pl-4 pr-4'>

                {/* ── Top bar ─────────────────────────────────────────────── */}
                <div className='w-[100%] flex justify-between items-center'>
                    <div className='flex items-center gap-6'>
                        <Link to='/WAMessage/WAFlow/Index'>
                            <FaArrowLeftLong />
                        </Link>
                        {/* Editable flow name */}
                        <input
                            value={flowName}
                            onChange={e => setFlowName(e.target.value)}
                            className='text-[#000] text-[14px] font-bold bg-transparent border-b border-transparent hover:border-[#ccc] focus:border-[#37715d] outline-none'
                        />
                    </div>

                    <div className='flex items-center gap-2'>
                        <button
                            onClick={() => setflowtype('build')}
                            className={`text-[12px] font-bold ${flowtype === 'build' ? 'border-[#37715d] text-[#000]' : 'border-[#0000] text-[#61748f]'} pb-2 border-b-[2px]`}>
                            Build
                        </button>
                        <button
                            onClick={() => setflowtype('Responses')}
                            className={`text-[12px] font-bold ${flowtype === 'Responses' ? 'border-[#37715d] text-[#000]' : 'border-[#0000] text-[#61748f]'} pb-2 border-b-[2px]`}>
                            Responses
                        </button>
                    </div>

                    <div className='flex items-center gap-2'>
                        {/* Save button */}
                        <button
                            onClick={saveFlow}
                            disabled={saving}
                            className='flex items-center gap-1 bg-[#37715d] hover:bg-[#2d5f4e] text-white text-[12px] font-bold py-2 px-3 rounded-md disabled:opacity-60 transition-colors'>
                            {saving
                                ? <AiOutlineLoading3Quarters className="animate-spin" />
                                : <MdOutlineSave />
                            }
                            {flowId ? 'Save' : 'Save & Create'}
                        </button>

                        <select className='hover:bg-[#37715d] hover:text-[#fff] text-[#37715d] font-bold text-[12px] py-2 px-1 rounded-md outline-none border-[1px] border-[#37715d]'>
                            <option>Aadvik Tech Services Private Limited</option>
                        </select>
                    </div>
                </div>

                {/* ── BUILD TAB ───────────────────────────────────────────── */}
                {flowtype === 'build' && (
                    <div className='w-[100%] flex border-[#e3e9ef] border-t-[1px] h-[100vh]'>

                        {/* Screen sidebar */}
                        <div className='border-[#e3e9ef] border-r-[2px] w-[15%] px-1'>
                            <div className='w-[100%] flex justify-end p-2'>
                                <button onClick={addScreen}
                                    className='text-[#3f7fca] text-[14px] font-bold flex items-center gap-1'>
                                    <IoMdAdd /> New Screen
                                </button>
                            </div>
                            <div className='w-[100%] mt-4 flex flex-col gap-4'>
                                {ScreenTabs.map((item) => (
                                    <div key={item.id} className='w-[100%] flex items-center justify-between gap-1'>
                                        <button
                                            onClick={() => { activeScreen(item.id); setisEditScreetitle(false); }}
                                            className={`px-4 py-2 rounded-lg w-[90%] text-[13px] ${activeTabId === item.id
                                                ? 'bg-[#37715d] text-white font-bold'
                                                : 'bg-[#edf1f5] text-[#555] font-normal'}`}>
                                            {item.text}
                                        </button>
                                        {ScreenTabs.length > 1 && (
                                            <div onClick={() => deleteButton(item.id)}
                                                className='p-2 hover:bg-[#d3dde6] bg-[#edf1f5] rounded-md flex items-center justify-center cursor-pointer'>
                                                <RiDeleteBin6Fill className='text-[#ed5050]' />
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Editor panel */}
                        <div className='border-[#e3e9ef] border-r-[2px] w-[60%] px-2 py-2 overflow-y-auto'>

                            {/* Screen title edit */}
                            {isEditScreenTitle ? (
                                <div className='flex flex-wrap gap-2 items-center my-2'>
                                    <input type="text"
                                        className='border-[1px] border-[#74777c] rounded-md outline-none sm:w-[400px] w-[100%] text-[12px] p-2'
                                        maxLength={50}
                                        value={newTitle}
                                        onChange={e => setnewTitle(e.target.value)}
                                    />
                                    <span className='text-[#74777caf] text-[14px]'>{newTitle.length}/50</span>
                                    <div onClick={() => { updatetitle(); setisEditScreetitle(false); }}
                                        className='p-2 bg-[#31b07b] text-[#fff] rounded-md flex justify-center items-center cursor-pointer'>
                                        <FaCheck />
                                    </div>
                                    <div onClick={() => setisEditScreetitle(false)}
                                        className='p-2 bg-[#c0c4c2] text-[#000] rounded-md flex justify-center items-center cursor-pointer'>
                                        <IoMdClose />
                                    </div>
                                </div>
                            ) : (
                                <div className='flex items-center gap-2'>
                                    <h4 className='text-[20px] text-[#576071] font-bold mt-2'>{selectedScreen?.text}</h4>
                                    <CiEdit
                                        onClick={() => {
                                            setisEditScreetitle(true);
                                            setnewTitle(selectedScreen.text);
                                            setSelectedId(selectedScreen.id);
                                        }}
                                        className='cursor-pointer mt-2' />
                                </div>
                            )}

                            {/* Containers */}
                            {selectedScreen?.containers.map((item, index) => (
                                <div key={item.id} className='border-[1px] border-[#e3e9ef] rounded-lg p-2 w-full mb-2'>
                                    <div className='w-full flex items-center justify-between'>
                                        <select
                                            value={item.bodyFont}
                                            onChange={e => updateContainer(index, 'bodyFont', e.target.value)}
                                            className='border-[#d4cfcf] border-[1px] rounded-md w-full sm:w-[300px] p-2 outline-none text-[#434a57] text-[12px] font-bold'>
                                            <option value="Largeheading">H1 Large heading</option>
                                            <option value="Smallheading">H2 Small heading</option>
                                            <option value="Caption">Caption</option>
                                            <option value="Body">Body</option>
                                        </select>
                                        <div className='flex gap-2'>
                                            <button onClick={() => duplicateContainer(index)}
                                                className="bg-[#edf1f5] text-[#000] p-2 rounded-lg">
                                                <FaCopy />
                                            </button>
                                            <button
                                                disabled={selectedScreen.containers.length <= 1}
                                                onClick={() => deletebodyitem(item.id)}
                                                className="bg-[#edf1f5] text-[#ed5050] p-2 rounded-lg disabled:opacity-40">
                                                <RiDeleteBin5Line />
                                            </button>
                                        </div>
                                    </div>
                                    <div className='w-full flex items-center justify-end'>
                                        <span className='text-[#74777caf] text-[12px] font-bold'>{item.bodyvalue.length}/4096</span>
                                    </div>
                                    <textarea
                                        className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-full'
                                        value={item.bodyvalue}
                                        rows={3}
                                        onChange={e => updateContainer(index, 'bodyvalue', e.target.value)}
                                    />
                                </div>
                            ))}

                            {/* Footer */}
                            <div className='border-[1px] border-[#e3e9ef] rounded-lg p-2 w-[100%] mb-4'>
                                <label className='text-[#585858] text-[12px] font-bold'>Footer button</label>
                                <div className='border-[#d4cfcf] border-[1px] rounded-md flex items-center gap-2 px-2'>
                                    <input
                                        className='text-[#454546] text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff] w-[100%]'
                                        type="text"
                                        value={selectedScreen.footer}
                                        onChange={e => {
                                            const updated = { ...selectedScreen, footer: e.target.value };
                                            syncSelectedScreen(updated);
                                        }}
                                        maxLength={35}
                                    />
                                    <span className='text-[#74777caf] text-[12px] font-bold'>{selectedScreen.footer.length}/35</span>
                                </div>
                            </div>

                            {/* Add content */}
                            <button
                                onClick={() => setisAddcontent(!isAddcontent)}
                                className='text-[#fff] bg-[#37715d] text-[12px] rounded-md font-bold p-2 flex items-center gap-1 mb-4'>
                                <IoMdAdd /> Add Content <IoIosArrowDown />
                            </button>

                            {isAddcontent && (
                                <div className='shadow-[0px_5px_15px_rgba(0,0,0,0.35)] rounded-lg p-2 w-[90%] my-4'>
                                    {contentOptions.map((section) => (
                                        <div key={section.category} className="w-[100%] mb-3">
                                            <label className="text-[#858c97] text-[12px] font-semibold block mb-1">
                                                {section.category}
                                            </label>
                                            <div className="w-[100%] flex flex-wrap justify-between gap-2">
                                                {section.items.map((item, idx) => {
                                                    const Icon = item.icon;
                                                    return (
                                                        <div className="w-[24%]" key={idx}>
                                                            <button
                                                                onClick={() => {
                                                                    addContainer(item.bodyFont, item.bodyvalue);
                                                                    setisAddcontent(false);
                                                                }}
                                                                className="w-[100%] border flex flex-col items-center justify-center hover:bg-[#ebebeb] rounded-md py-3">
                                                                <Icon size={20} className="mb-1" />
                                                                <small className='text-[#858c97] text-[11px] font-bold'>{item.text}</small>
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Preview pane */}
                        <div className='w-[100%] md:w-[26%] p-4 flex justify-center sm:mt-[-15px] mt-[30px]'>
                            <div className='scale-[.90] origin-top'>
                                <div className='w-[300px] bg-cover bg-center h-[600px] flex justify-center items-center'
                                    style={{ backgroundImage: `url(${whatsappBgimage})` }}>
                                    <div className='w-[266.5px] bg-contain bg-center bg-no-repeat bg-[#FFF] h-[570px] rounded-[40px]'>
                                        <div className='bg-[#00816a] h-[75px] w-[100%] rounded-t-[20px] ml-[.5px] relative overflow-hidden'>
                                            <div className='w-[100%] flex justify-between px-2'>
                                                <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                                    <span>12:00</span><FaWhatsapp /><FaInstagram />
                                                </div>
                                                <img src={whatsappnotch} alt="" className='w-[100px] h-[20px] object-content mt-[-10px]' />
                                                <div className='flex items-center gap-2 text-[12px] text-[#fff]'>
                                                    <FaWifi /><MdOutlineSignalCellularConnectedNoInternet4Bar /><MdBatteryFull />
                                                </div>
                                            </div>
                                            <div className='w-[100%] flex px-2 items-center justify-between py-1 gap-1'>
                                                <div className='flex items-center text-[#fff] gap-1'>
                                                    <FaArrowLeftLong className='text-[28px]' />
                                                    <img src={Whatsappicon} alt="" className='w-10 h-10' />
                                                    <div className='flex flex-col'>
                                                        <span className='text-[12px] text-[#fff] font-bold'>Flow Preview</span>
                                                    </div>
                                                </div>
                                                <div className='flex flex-col gap-1 text-[#fff]'>
                                                    <FaShop /><RxDotsVertical />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='w-[100%] h-[500px] flex flex-col items-baseline justify-between'>
                                            <div className='w-[100%] pt-3 overflow-y-auto max-h-[440px]'>
                                                <div className='w-[100%] flex flex-col items-center justify-center pb-2'>
                                                    <div className='w-[20px] h-[2px] bg-[#576071]'></div>
                                                    <h4 className='text-[14px] text-[#576071] font-bold mt-2'>{selectedScreen?.text}</h4>
                                                </div>
                                                <div className='border-t-[1px] border-[#e3e9ef] px-2 w-[100%]'>
                                                    {selectedScreen.containers.map((item) => (
                                                        <p key={item.id} style={{ whiteSpace: 'pre-line' }}
                                                            className={`font-bold mt-2 break-words
                                                                ${item.bodyFont === 'Body' ? 'text-[12px] text-[#576071]' : ''}
                                                                ${item.bodyFont === 'Largeheading' ? 'text-[24px] text-[#000]' : ''}
                                                                ${item.bodyFont === 'Smallheading' ? 'text-[18px] text-[#000]' : ''}
                                                                ${item.bodyFont === 'Caption' ? 'text-[10px] text-[#576071]' : ''}
                                                            `}>
                                                            {item.bodyvalue}
                                                        </p>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className='border-[#e3e9ef] border-t-[1px] pt-2 pb-6 w-[100%] px-3'>
                                                <button className="bg-[#37715d] text-white px-4 py-2 rounded-[40px] w-[100%] font-bold text-[13px] break-words">
                                                    {selectedScreen.footer}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ── RESPONSES TAB ──────────────────────────────────────── */}
                {flowtype === 'Responses' && (
                    <div className='border-[#e3e9ef] border-t-[1px]'>
                        <ResponsesTab flowId={flowId} />
                    </div>
                )}
            </div>
        </>
    );
}

export default AddEditFlow;